import { useAppLoad } from '@/composables/app-load';
import { Role } from '@/model/role';
import { useUsersStore } from '@/store/users-store';
import { useRouter } from 'vue-router';

interface SpaceSnapshot {
  vendorId: number | null;
  role: Role | null;
}

export function useSpaceGuard() {
  const usersStore = useUsersStore();
  const router = useRouter();
  const { loadManagerData } = useAppLoad();

  function currentSpace(): SpaceSnapshot {
    return {
      vendorId: usersStore.loggedInVendorId,
      role: usersStore.loggedInUserRole,
    };
  }

  async function followImposedChange(previous: SpaceSnapshot) {
    const current = currentSpace();
    if (
      previous.vendorId === current.vendorId &&
      previous.role === current.role
    ) {
      return;
    }
    if (previous.vendorId !== current.vendorId) {
      usersStore.resetVendorData();
      await usersStore.getUser(usersStore.loggedInUserId);
      await loadManagerData();
    }
    await router.isReady();
    const { path, query, hash } = router.currentRoute.value;
    await router.replace({ path, query, hash, force: true });
  }

  return usersStore.$onAction(({ name, after }) => {
    if (name !== 'refreshToken' || usersStore.user.switchingSpace) {
      return;
    }
    const previous = currentSpace();
    after(() => followImposedChange(previous));
  });
}
